<template>
<div>
    <v-dialog v-model="open" scrollable max-width="800">
        <v-card>
            <v-system-bar color="megogo" dark>
                <v-spacer></v-spacer>

                <v-icon @click="open = false">mdi-close</v-icon>
            </v-system-bar>
            <v-card-title class="headline">Перевірка продажу</v-card-title>
            <v-card-text>
                <v-alert type="info" color="infolight" class="my-8 cardheaderdark--text" v-if="reminderData.length === 0">На заданий номер телефону покупця продажів не було.</v-alert>
                <v-simple-table v-if="reminderData.length > 0">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Дата</th>
                                <th class="text-left">Пакет</th>
                                <th class="text-left">Вартість</th>
                                <th class="text-right">Код активації</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in reminderData" :key="item.id">
                                <td>{{ item.date }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.price }} грн</td>
                                <td class="text-right">
                                    <v-btn dark color="red" @click="remind(item.id)">Нагадати</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-progress-linear :active="remindLoading" color="error" ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

export default {
    props: {
        phone: String,
        opened: Boolean
    },
    components: {},
    data() {
        return {
            open:  false,
            remindLoading: false
        }
    },
    methods: {
        ...mapActions(['getCodesByPhone', 'remindeCode']),
        remind(id) {
            this.remindLoading = true
            this.remindeCode({
                id: id
            })
            .then(() => this.remindLoading = false)
        },
    },
    created() {

    },
    computed: {
        reminderData() {
            return this.$store.state.megogo.reminderData
        }
    },
    watch: {
        opened: {
            handler() {
                this.open = this.opened
            }
        },
        open: {
            handler() {
                this.$emit('update:opened', this.open)
            }
        }
    }
}
</script>
